const simulation = {
  state: {
    timeout: false,
    beforeLogout: false,
    currentPart: { part: null, isPaused: false }, // 当前的组件，用于判断组件自身是否已经销毁，若销毁，停止相关逻辑如settimeout等,
    examnationRecording: false,
    storeTranslationLanguage: sessionStorage.getItem('translationLanguage') || 'en-us',
    inputDeviceId: sessionStorage.getItem('inputDeviceId')|| 'default'
  },
  mutations: {
    SET_TIMEOUT(state, data) {
      state.timeout = data
    },
    SET_LOGOUT(state, data) {
      state.beforeLogout = data
    },
    SET_CURRENT_COMPONENT(state, data) {
      console.log('设置当前的听力判断', data.part, data.isPaused)
      if (typeof data.part == 'string') state.currentPart.part = data.part
      if (typeof data.isPaused == 'boolean') state.currentPart.isPaused = data.isPaused
    },
    SET_EXAMNATION_RECORD(state, data) {
      state.examnationRecording = data
    },
    SET_EXAMNATION_TRANSLATION_LANGUAGE(state, data) {
      console.log('store change')
      state.storeTranslationLanguage = data
       sessionStorage.setItem('translationLanguage', data)
    },
    SET_INPUT_DEVICEID(state, data) { 
      console.log('commit生效')
      state.inputDeviceId = data
      sessionStorage.setItem('inputDeviceId', data)
    }
  },
  actions: {
    notificationTimeout({ commit }, data) {
      commit('SET_TIMEOUT', data)
    },
    notifLogout({ commit }, data) {
      commit('SET_LOGOUT', data)
    },
    // 设置听力环节的当前配置，控制听力题目的流程，例如 { part: 'listen', isPaused: false }
    setPartForAudio({ commit }, data) {
      commit('SET_CURRENT_COMPONENT', data)
    },
  },
}

export default simulation
